import Grid from '@mui/material/Grid';
import { withStyles } from 'utils/styles';
import Header from 'connectedComponents/Header/index';
import ErrorAlert from 'connectedComponents/ErrorAlert';
import PersistentAlert from 'connectedComponents/PersistentAlert';
import Loader from 'components/Loader/index';
import React from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { currentUser } from 'selectors/currentUser';
import adminSections from 'utils/navigationSections/adminSidebarSections';
import userSections from 'utils/navigationSections/userSidebarSections';

const styles = () => ({
  container: {
    bottom: 0,
    left: 0,
    position: 'relative',
    right: 0,
    top: 64,
    height: 'calc(100vh - 64px)'
  }
});

/*
 * Everything a signed-in screen has around it: the header with its sections, the
 * two alert bars, and the frame the page is drawn in.
 *
 * This was the `React.Fragment` inside the old `<Switch>`, and it was a Fragment
 * because router 5 needed a single child there - which is why React 19 warned
 * about a Fragment being handed a `location` prop it cannot take. As a layout
 * route it is a component with an `<Outlet/>`, which is what it always was.
 *
 * `booting` is still answered here rather than in the router: the loader has to
 * win over whatever route matched, and the sections depend on who is asking.
 */
const Shell = ({ booting, classes, user }) => {
  if (booting) {
    return <Loader/>;
  }

  return (
    <React.Fragment>
      <Header sections={user.superuser ? adminSections : userSections(user)}/>
      <ErrorAlert/>
      <PersistentAlert/>
      <Grid className={classes.container} container spacing={0}>
        <Outlet/>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  booting: state.bootstrap.booting,
  user: currentUser(state)
});

export default connect(mapStateToProps)(withStyles(styles)(Shell));
